import types from "./types";

const INITIAL_STATE = {
  visitorList: null,
  visitorListError: null,
  visitorListLoading: false,

  //create
  createvisitor: null,
  createvisitorError: null,
  createvisitorLoading: false,

  //update
  updatevisitor: null,
  updatevisitorError: null,
  updatevisitorLoading: false,

  //delete
  deletevisitor: null,
  deletevisitorError: null,
  deletevisitorLoading: false,

  //single item
  singleItem: null,
};

const labVisitorReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.GET_LAB_VISITOR_START:
      return {
        ...state,
        visitorList: null,
        visitorListError: null,
        visitorListLoading: true,
      };
    case types.GET_LAB_VISITOR_SUCCESS:
      return {
        ...state,
        visitorList: action.payload,
        visitorListLoading: false,
      };
    case types.GET_LAB_VISITOR_ERROR:
      return {
        ...state,
        visitorListError: action.payload,
        visitorListLoading: false,
      };
    case types.GET_LAB_VISITOR_RESET:
      return {
        ...state,
        visitorListError: null,
        visitorListLoading: false,
      };
    //create

    case types.CREATE_LAB_VISITOR_START:
      return {
        ...state,
        createvisitor: null,
        createvisitorError: null,
        createvisitorLoading: true,
      };
    case types.CREATE_LAB_VISITOR_SUCCESS:
      return {
        ...state,
        createvisitor: action.payload,
        createvisitorLoading: false,
      };
    case types.CREATE_LAB_VISITOR_ERROR:
      return {
        ...state,
        createvisitorError: action.payload,
        createvisitorLoading: false,
      };
    case types.CREATE_LAB_VISITOR_RESET:
      return {
        ...state,
        createvisitorError: null,
        createvisitorLoading: false,
      };
    //delete

    case types.DELETE_LAB_VISITOR_START:
      return {
        ...state,
        deletevisitor: null,
        deletevisitorError: null,
        deletevisitorLoading: true,
      };
    case types.DELETE_LAB_VISITOR_SUCCESS:
      return {
        ...state,
        deletevisitor: action.payload,
        deletevisitorLoading: false,
      };
    case types.DELETE_LAB_VISITOR_ERROR:
      return {
        ...state,
        deletevisitorError: action.payload,
        deletevisitorLoading: false,
      };
    case types.DELETE_LAB_VISITOR_RESET:
      return {
        ...state,
        deletevisitor: null,
        deletevisitorError: null,
        deletevisitorLoading: false,
      };

    //update
    case types.UPDATE_LAB_VISITOR_START:
      return {
        ...state,
        updatevisitor: null,
        updatevisitorError: null,
        updatevisitorLoading: true,
      };
    case types.UPDATE_LAB_VISITOR_SUCCESS:
      return {
        ...state,
        updatevisitor: action.payload,
        updatevisitorLoading: false,
      };
    case types.UPDATE_LAB_VISITOR_ERROR:
      return {
        ...state,
        updatevisitorError: action.payload,
        updatevisitorLoading: false,
      };
    case types.UPDATE_LAB_VISITOR_RESET:
      return {
        ...state,
        updatevisitor: null,
        updatevisitorError: null,
        updatevisitorLoading: false,
      };
    //singleItem
    case types.SINGLE_LAB_VISITOR_START:
      return {
        ...state,
        singleItem: null,
        singleItemError: null,
        singleItemLoading: true,
      };
    case types.SINGLE_LAB_VISITOR_SUCCESS:
      return {
        ...state,
        singleItem: action.payload,
        singleItemLoading: false,
      };
    case types.SINGLE_LAB_VISITOR_ERROR:
      return {
        ...state,
        singleItemError: action.payload,
        singleItemLoading: false,
      };
    case types.SINGLE_LAB_VISITOR_RESET:
      return {
        ...state,
        singleItem: null,
        singleItemError: null,
        singleItemLoading: false,
      };

    default:
      return { ...state };
  }
};

export default labVisitorReducer;
